import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";

export default function DeletePatient({ patient, onClose }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const { busy, error, run } = useSubmit();
  const del = () => run(async () => {
    await api.post(`/patients/${patient.id}/delete`, { confirm_name: name });
    toast.success(`${patient.name} and all their records were deleted`);
    navigate("/patients", { replace: true });
  });
  return (
    <Modal eyebrow="DELETE PATIENT" title={`Delete ${patient.name}?`} onClose={onClose} onSubmit={del} testid="delete-patient-form">
      <p className="muted">This permanently removes the patient and all their clinical notes, treatments, payments and appointments. Lab cases stay in the lab ledger so what you owe each lab is not lost. This cannot be undone.</p>
      <Field label={`Type "${patient.name}" to confirm`} required testid="delete-patient-confirm-input" value={name} onChange={setName} />
      <ErrorBox error={error} testid="delete-patient-error" />
      <button className="danger full" disabled={busy || name.trim().toLowerCase() !== patient.name.trim().toLowerCase()} data-testid="confirm-delete-patient-button"><Trash2 size={16} /> {busy ? "Deleting…" : "Delete permanently"}</button>
    </Modal>
  );
}
